import { Pipe, PipeTransform } from '@angular/core';
import { replace as _replace } from 'lodash-es';


@Pipe({
  name: 'interpolate'
})
export class InterpolatePipe implements PipeTransform {

  transform(text: string, replaceText: string, replacedWith: any): string {
    if (replaceText !== '') {
      return _replace(text, replaceText, replacedWith);
    }
    return text;
  }

}
